import { WithRouterProps } from 'app/components/enhancers/with-router';
import * as React from 'react';
import { Favourite } from './favourite';
import { FavouriteInstance } from './favourite-context';

interface FavouriteRouteProps {
  location: { query: { report: string; openFilters?: string; editSavedFavourite?: string }};
  params: { favouriteId: string };
}

export function FavouriteRoute(props: FavouriteRouteProps & WithRouterProps) {
  
  const { params, router: { location: { query } } } = props;

  const report = query?.report ?
    parseInt(query.report, 10) :
    undefined;
  
  const favouriteId = params?.favouriteId && parseInt(params.favouriteId, 10);

  const intiallyOpenFilter = Boolean(query?.openFilters);

  const editSavedFavourite = Boolean(query?.editSavedFavourite);
  
  return (
    <FavouriteInstance>
      <Favourite
        editSavedFavourite={editSavedFavourite}
        initiallyOpenFilter={intiallyOpenFilter}
        overrideReport={report}
        favouriteId={favouriteId}
      />
    </FavouriteInstance>
  );
}
